/* global site: false, __: false, app: true, win: true, urlParams: false, pad: false, Vimeo: false, grecaptcha: false */
if(sessionStorage.getItem('alert-hidden')){
	$('#alert-message').hide();
}

$('#backdrop').removeAttr('style');
$('#modal').hide();

$(document).ready(function(){
	app.head = $('header[role="banner"]');
	app.headHeight = app.head.outerHeight();
	app.scrollToTop = $('#scroll-to-top');
	app.searchOpen = false;
	app.mediaBreaks = {
		phone_small: 365,
		phone: 600,
		tablet: 768,
		laptop: 1120,
		desktop: 1640
	};

	var adjustHeader = (function adjustHeader(){
		$('body').css('margin-top', app.headHeight);

		if($('#hero-banner').length){
			$('#hero-banner').css('height', 'calc(100vh - ' + app.headHeight + ')');
		}

		if($('#subpage-banner').length){
			$('#subpage-banner').css('background-position', '0 0, 25vw ' + (win.innerWidth() <= app.mediaBreaks.tablet ? '55%' : '10%') + ', 0 ' + app.headHeight + 'px');
		}

		return adjustHeader;
	})();

	(function(){
		if(!$('#banner-video').length) return;

		var player = new Vimeo.Player($('#banner-video')[0]),
			control = $('.video-control');

		$('.video-control').click(function(){
			player.getPaused().then(function(paused){
				if(paused){
					player.play();
				}else{
					player.pause();
				}
			});
		});

		player.on('play', function(){
			control.text($('<textarea />').html('&#xf04c;').text());
		});

		player.on('pause', function(){
			control.text($('<textarea />').html('&#xf04b;').text());
		});
	})();

	(function(){
		var iframes = [];

		$('iframe[src*="player.vimeo.com"]').each(function(){
			let player = new Vimeo.Player($(this)[0]),
				ni;

			iframes.push(player);

			player.on('play', function(){
				for(ni = 0; ni < iframes.length; ++ni){
					if(iframes[ni] !== player){
						iframes[ni].pause();
					}
				}
			});
		});
	})();

	$('.close-alert-button').click(function(e){
		var alertBar = $('#alert-message'),
			alertBarInner = $('.alert-message-inner');

		e.preventDefault();

		sessionStorage.setItem('alert-hidden', 'true');
		alertBarInner.slideUp();
		alertBar.animate({height: 0}).promise().done(function(){
			alertBar.remove();
			app.headHeight = app.head.outerHeight();
			adjustHeader();
		});
	});

	/**
	 * Add and removes the hasValue class from inputs for label position
	 */
	$('input, textarea').each(function(){
		var that = $(this);

		if(that.val()){
			that.addClass('hasValue');
			that.nextAll('.clear-input').click(function(e){
				that.val('');
				that.removeClass('hasValue');
			});
		}
	}).on('blur', function(){
		var that = $(this);

		if(that.val()){
			that.addClass('hasValue');
			that.nextAll('.clear-input').click(function(e){
				that.val('');
				that.removeClass('hasValue');
			});
		}else{
			that.removeClass('hasValue');
		}
	});

	$('.menu-item-has-children').each(function(){
		var elem = this;

		elem.isOpen = false;
		$(elem).click(function(e){
			// close all the other sub menus
			$('.menu-item-has-children').each(function(){
				var otherElem = this;

				if(elem !== otherElem){
					otherElem.isOpen = false;
					$(otherElem).removeClass('open');
				}
			});

			elem.isOpen = !elem.isOpen;

			if(elem.isOpen){
				e.preventDefault();
				$(elem).addClass('open');
			}else{
				// need to check if we arent clicking on a submenu item
				if(e.target === elem || e.target.parentNode === elem && win.outerWidth() > app.mediaBreaks.tablet){
					e.preventDefault();
					$(elem).removeClass('open');
					e.target.blur();
				}
			}
		});
	});

	$('#search-toggle').click(function(e){
		app.searchOpen = !app.searchOpen;

		if(app.searchOpen){
			$('#search-form').show();
		}else{
			$('#search-form').hide();
		}
	});

	$('#close-search').click(function(e){
		app.searchOpen = false;
		$('#search-form').hide();
	});

	// Close all submenus when clicking elsewhere on the screen
	$(window).click(function(e){
		if(!$('.menu-item-has-children').is($(e.target).closest('.menu-item-has-children')) && win.outerWidth() > app.mediaBreaks.tablet){
			$('.menu-item-has-children').each(function(){
				this.isOpen = false;
				$(this).removeClass('open');
			});
		}
	});

	$('.back-link').click(function(e){
		e.stopPropagation();
		$('.menu-item-has-children').each(function(){
			this.isOpen = false;
			$(this).removeClass('open');
		});
	});

	/**
	 * Changes the language in a ~~super~~ much less jank way.
	 */
	$('#language-switcher').change(function(e){
		var that = $(this);

		window.location = $('link[hreflang="' + that.val() + '"]').attr('href');
	});

	/**
	 * Creates the signup modal and from submition for the signup
	 */
	$('#footer-signup-link').click(function(e){
		e.preventDefault();

		app.makeModals('signup-modal');
		app.modalContent.load(site.theme.uri + '/views/signup.twig' + '?_=' + (new Date()).getTime(), function(){
			$('#footer-signup input#user_signup_email').focus();
			$('#footer-signup input').on('blur', function(){
				if($(this).val()){
					$(this).addClass('hasValue');
				}else{
					$(this).removeClass('hasValue');
				}
			});

			$('#footer-signup').submit(function(e){
				var that = $(this);

				e.preventDefault();
				that.find('button[type="submit"]').prop('disabled', true);
				app.doSignup(urlParams(that.serialize()), function(data){
					if(data.status && data.status > 0){
						$('#footer-login').removeClass('show');
						$('#footer-username').html(__('Welcome Back %s!', data.name, 'kapalama_kai'));
						$('#footer-logout').addClass('show');
						$('nav[role="navigation"] ul').append('<li><a href="' + site.url + '/users/' + data.cleanName + '" title="My Page">My Page</a></li>');
						app.modalClose();
					}

					that.find('button[type="submit"]').removeAttr('disabled');
				});
			});
		});
	});

	/**
	 * Creates the image modal. Currently works on img tags with class modal-img.
	 * the data-target att on the img should be a link to the full size image. if no target is provided, the src is used
	 */
	$('img.modal-img').click(function(e){
		var src = $(this).attr('data-target') || $(this).attr('src'),
			img = document.createElement('img');

		app.makeModals('image-modal');
		img.src = src;
		img.onload = function(){
			app.modalContent.html(img);
			app.modal.css({
				'height': $(img).height(),
				'width': $(img).width(),
				'top': -$(img).height() / 2,
				'margin': '50vh auto 0'
			});
		};
	});

	/**
	 * Creates an ajax modal. Currently works on anchor tags with class modal-ajax and pulls out the data-target attr.
	 * that attr should be a class/id/attr on the target page. if no data-target is present, the role="main" content is used
	 */
	$('a.modal-ajax').click(function(e){
		var url = $(this).attr('href') + '?modal',
			target = $(this).attr('data-target') || 'article[role="article"]';

		e.preventDefault();
		app.makeModals('content-modal');
		$.get(url, function(data){
			if($(data).find(target).length){
				app.modalContent.html($(data).find(target));
			}else{
				app.modalContent.html($(data).find('article[role="article"]'));
			}

			app.observeIntersections(app.modal[0]);
		});
	});

	/**
	 * This makes the sidebar sticky, if it exists.
	 */
	if($('aside[role="complementary"]').length && $(window).width() > 980){
		var sidebarWrapper = $('aside[role="complementary"]'),
			stop = $('footer[role="contentinfo"]'),
			wd, hi;

		app.sidebarInner = $('aside[role="complementary"] > div');

		app.moveSidebar = function(){
			if(win.scrollTop() >= sidebarWrapper.offset().top - 20 && app.sidebarInner.height() < win.height() - app.head.height()){
				wd = app.sidebarInner.width();
				hi = app.sidebarInner.height();
				sidebarWrapper.css('height', sidebarWrapper.height());
				app.sidebarInner.css({
					'position': 'fixed',
					'top': 20,
					'width': wd,
					'height': hi
				});
			}else{
				app.sidebarInner.removeAttr('style');
				sidebarWrapper.removeAttr('style');
			}

			if(win.scrollTop() + app.sidebarInner.height() >= stop.offset().top - 41){
				app.sidebarInner.css({
					'top': stop.offset().top - win.scrollTop() - hi - 21
				});
			}

			return app.sidebarInner.offset().top;
		};
	}

	$('nav[role=navigation] ul ul a').focus(function(){
		var that = $(this);

		that.closest('ul').prev('a').addClass('child-has-focus');
	}).blur(function(){
		var that = $(this);

		that.closest('ul').prev('a').removeClass('child-has-focus');
	});

	/**
	 * The actions for the button that shows/hides the menu on mobile.
	 * TODO Find a better way to apply the no-scroll class to the body. i dont like doing it based on a number. or at least a static number
	 */
	$('#burger, .close-sidebar').click(function(e){
		e.preventDefault();
		$('#burger, .mobile-nav-wrap').toggleClass('show');
		$('.mobile-nav-wrap, .mobile-nav-wrap ul>li>ul').css('top', app.headHeight);
		$('.mobile-nav-wrap ul>li>ul').css('bottom', $('#mobile-search-form').outerHeight());

		if(win.outerWidth() <= app.mediaBreaks.phone){
			$('body').toggleClass('no-scroll');
			$('#backdrop').toggleClass('show');
		}
	});

	/**
	 * Just a thing to make the window scroll
	 */
	app.scrollToTop.click(function(e){
		scrollTo('html');
	});

	/**
	 * Grabs all the hash links and runs the scrollTo function
	 */
	$('a[href*="#"]').click(function(e){
		if(location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname){
			e.preventDefault();
			scrollTo(this.hash);
			$(this.hash).attr('tabindex', '-1').focus().blur().removeAttr('tabindex');
		}
	});

	/**
	 * Shows and hides FAQ content on all pages that use the shortcode
	 */
	$('.faq-slide-content h4').click(function(e){
		var that = $(this),
			hasClass = that.nextAll('div').hasClass('open');

		$('.faq-slide-content div').removeClass('open');

		if(!hasClass){
			setTimeout(function(){
				that.nextAll('div').addClass('open');
			}, 301);
		}
	});

	/**
	 * format phone numbers on input blur
	 * @return {[type]} [description]
	 */
	$('input[type="tel"]').blur(function(){
		$(this).val(app.formatPhoneNumber($(this).val()));
	});

	/**
	 * Attach calendars to all inputs of type "date"
	 */
	$('input[type="date"]').each(function(){
		var that = $(this),
			date = app.calendar({
				element: app.createCal(),
				on_select: function(newDate){
					that.val(function(){
						return newDate.getFullYear() + '-' + pad(newDate.getMonth() + 1, 2) + '-' + pad(newDate.getDate(), 2);
					});
					that.addClass('hasValue');
					that.nextAll('.clear-input').click(function(e){
						that.val('');
						that.removeClass('hasValue');
						date.element.removeClass('show');
					});
					date.element.removeClass('show');
				},
				is_valid: function(date){
					return date.getTime() > new Date().getTime();
				}
			});

		that.parent().append(date.element).click(function(e){
			if(e.target === that[0]){
				$('.calendar').removeClass('show');
				that.siblings(date.element).addClass('show');
				win.on('click', date.close);
			}
		});
	});

	/**
	 * move the sidebar and parallaxes on page load in case the window isnt at the top
	 */
	if(typeof app.moveSidebar === 'function') app.moveSidebar();

	if(win.scrollTop() >= app.head.offset().top + app.head.outerHeight()){
		app.scrollToTop.addClass('show');
	}

	/**
	 * Adds scrollEvent function to various event listeners.
	 * This was done to make sure all scrolling events (ie touch, scroll, etc) are in passive mode.
	 */
	for(var ni = 0; ni < app.movementEvents.length; ++ni){
		document.addEventListener(app.movementEvents[ni], app.scrollEvent, {passive: true});
	}

	$('.form-builder').submit(app.validateForm(function(that, errors){
		if(errors.length < 1){
			var opts = urlParams(that.serialize()),
				data = {},
				formData = new FormData(that[0]),
				item;

			that.find('input[type="file"]').each(function(){
				var fileInput = $(this),
					file = fileInput[0].files[0];

				formData.append(fileInput.attr('name'), file);
			});

			formData.append('action', 'submit_form_builder');
			data.fields = {};

			for(item in opts){
				if(item === 'form_id'){
					data[item] = opts[item];
				}else{
					data.fields[item] = opts[item];
				}
			}

			that.find('[type="submit"]').attr('disabled', true);

			$.ajax({
				type: 'POST',
				url: app.ajaxUrl,
				data: formData,
				processData: false,
				contentType: false,
				success: function(data){
					if(parseInt(data, 10) !== 0){
						if(data.status > 0){
							app.notification(__('Form Submitted!'), 'success');
							that.html('<h2 class="text-center">Form Submitted Successfully!</h2>');
						}else{
							app.notification(data.errors, 'error');
							that.find('[type="submit"]').attr('disabled', false);
						}
					}else{
						app.notification(__('Internal error. Please try again.', 'kapalama_kai'), 'error');
						that.find('[type="submit"]').attr('disabled', false);
					}

					return data !== 0;
				}
			});
		}
	}));

	$('#mailchimp-signup').submit(app.validateForm(function(that, errors){
		var formData = urlParams(that.serialize()),
			message = that.find('meta[name="form-success-message"]').attr('content') || __('Form Submitted Successfully!', 'kapalama_kai'),
			data = {
				action: 'mail_chimp_add_member',
				data: formData
			},
			ni;

		/**
		 * submit the data to the back end
		 * @return {[type]} [description]
		 */
		function doAjax(){
			$.ajax({
				type: 'POST',
				url: app.ajaxUrl,
				data: data,
				success: function(resp){
					if(parseInt(resp, 10) !== 0){
						if(resp.status > 0){
							that.html('<h3 class="col-xs text-center">' + message + '</h3>');
						}else{
							app.notification(resp.errors, 'error');
						}
					}else{
						app.notification(__('Internal error. Please try again.', 'kapalama_kai'), 'error');
					}

					that.find('[type="submit"]').attr('disabled', false);

					return resp !== 0;
				}
			});
		}

		if(errors.length < 1){
			that.find('[type="submit"]').attr('disabled', true);

			if(site.recaptchaSiteKey){
				grecaptcha.ready(function(){
					grecaptcha.execute(site.recaptchaSiteKey, {action: 'submit'}).then(function(token){
						data['g-recaptcha-response'] = token;
						doAjax();
					});
				});
			}else{
				doAjax();
			}
		}else{
			for(ni = 0; ni < errors.length; ++ni){
				app.notification(errors[ni].message, 'error');
			}
		}
	}));

	$(window).resize(function(){
		app.headHeight = app.head.outerHeight();
		adjustHeader();
	});
});

/**
 * Hide the fullscreen loader. This happens at window.load so we can wait for all images to load too
 */
$(window).on('load', function(){
	app.observeIntersections();
	$('#fullscreen-loading').addClass('hide');
	$('.blur').removeClass('blur');
	setTimeout(function(){
		$('#fullscreen-loading').remove();
		$('body').removeClass('no-scroll');
		if(typeof app.afterLoad === 'function'){
			app.afterLoad();
		}
	}, 301);

	setTimeout(function(){
		$('.parallax').each(function(){
			var that = $(this),
				height = that.height(),
				top = that.offset().top,
				img = document.createElement('img');

			img.src = that.css('background-image').replace(/url\(['|"]?(.*[^'|"])['|"]?\)/, '$1');
			that[0].top = top;
			that[0].bottom = top + height;
			that[0].center = that[0].style.backgroundPositionY ? (parseInt(that[0].style.backgroundPositionY) / 100) * height : height / 2;
			img.onload = function(){
				that[0].amount = that.height() / win.height();
				app.moveParallax(that);
			};
		});
	}, 100);
});
